var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaCompetitorsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-competitors-icon_svg__a",
    d: "M0 0h45.901v40.164H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-competitors-icon_svg__c",
    d: "M0 0h30.984v39.815H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-competitors-icon_svg__e",
    d: "M0 0h10.284v26.047H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.279 7.059a5.4 5.4 0 11-10.803 0 5.402 5.402 0 0110.803 0",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.705 9.18c-15.527 0-28.114 12.588-28.114 28.115 0 11.662 7.1 21.664 17.213 25.922v-4.692h14.918v-13.77H51.64V30.983h8.46C57.234 18.497 46.062 9.18 32.705 9.18",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.656 29.836)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-competitors-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-competitors-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.148 40.164A1.148 1.148 0 010 39.016V28.69c0-.634.514-1.148 1.148-1.148h13.77V14.918c0-.633.514-1.148 1.148-1.148h13.77V1.148C29.836.514 30.35 0 30.984 0h13.77a1.148 1.148 0 010 2.295H32.131v12.623c0 .633-.514 1.148-1.147 1.148h-13.77v12.623c0 .633-.515 1.147-1.148 1.147H2.296v9.18c0 .634-.515 1.148-1.148 1.148",
    fill: "#020303",
    mask: "url(#ea-competitors-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.345 40.638l-9.983-7.36V20.655c0-2.688-1.821-3.159-4.247-4.403-1.998-1.024-3.977-1.338-6.081-.505v18.29c0 1.469.282 2.997 1.106 4.176L1.149 61.967h5.737l7.906-20.745 7.27 2.8 2.037 8.765h5.738l-1.492-12.15z",
    fill: "#E74B0F"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-competitors-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-competitors-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.835 39.815a1.148 1.148 0 01-1.138-1.007l-1.43-11.66-9.587-7.065a1.146 1.146 0 01-.467-.924V6.536c0-1.538-.64-1.923-2.664-2.907-.306-.15-.626-.305-.958-.476-2.223-1.138-4.087-1.146-6.05-.024a35.118 35.118 0 00-4.139 2.766c-.666.555-1.107 1.564-1.107 2.557v9.56a1.147 1.147 0 11-2.295 0v-9.56C0 6.78.747 5.122 1.947 4.12c.09-.074 1.895-1.522 4.455-2.985 2.636-1.507 5.33-1.515 8.236-.024.317.162.623.311.916.453 2.033.99 3.954 1.924 3.954 4.971V18.58l9.518 7.014c.254.188.42.471.459.785l1.49 12.149a1.149 1.149 0 01-1.14 1.287",
    fill: "#020303",
    mask: "url(#ea-competitors-icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.886 63.115a1.148 1.148 0 01-1.073-1.556l7.906-20.745a1.148 1.148 0 012.145.817L7.959 62.375a1.15 1.15 0 01-1.073.74",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 37.068)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-competitors-icon_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-competitors-icon_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.148 26.047A1.147 1.147 0 01.06 24.533L8.05.781a1.148 1.148 0 012.174.733l-7.988 23.75c-.162.48-.608.783-1.088.783",
    fill: "#020303",
    mask: "url(#ea-competitors-icon_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.213 2.295a4.595 4.595 0 00-4.59 4.59 4.595 4.595 0 004.59 4.59 4.595 4.595 0 004.59-4.59 4.595 4.595 0 00-4.59-4.59m0 11.475a6.892 6.892 0 01-6.885-6.885A6.892 6.892 0 0117.213 0 6.892 6.892 0 0124.1 6.885a6.892 6.892 0 01-6.886 6.885M26.393 32.131c-.193 0-.39-.048-.568-.151l-8.033-4.59a1.147 1.147 0 111.138-1.993l8.033 4.59a1.147 1.147 0 01-.57 2.144M24.098 53.934c-.523 0-.994-.358-1.117-.888l-1.898-8.171-10.408-4.009c-2.458-1.057-3.79-3.476-3.79-6.829V21.803a1.148 1.148 0 012.296 0v12.234c0 2.448.794 4.03 2.36 4.705l10.934 4.21c.356.137.618.44.706.812l2.035 8.764a1.147 1.147 0 01-1.118 1.406",
    fill: "#020303"
  }))));
}
export default SvgEaCompetitorsIcon;